import { Component, OnInit, TemplateRef } from '@angular/core';
import { ClienteService } from 'src/app/shared/services/cliente.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SenhaT } from './SenhaT';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public openDashboard: boolean = false;
  usuarioId = null;
  usuarioCompleto;
  selectedUsuario;
  editTrocaSenha: FormGroup | null = null;
  acao;
  id;
  senhaTroca = new SenhaT();

  constructor(
    public usuarioService: UsuarioService,
    private router: Router,
    public clienteService: ClienteService,
    private modalService: NgbModal,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.editTrocaSenha = this.fb.group({
      senhaA: [''],
      novaS: [''],
  });
    this.getUsuario();
  }

  getUsuario() {
    this.usuarioId = JSON.parse(localStorage.getItem('localUserTour'))
    if (this.usuarioId != null) {
      var token = JSON.parse(localStorage.getItem('localUserTour')).token;
      this.usuarioService.getUsuarioByIdV(this.usuarioId.id, token).subscribe(data => {
        localStorage.setItem('localUserTourLogado', 'validado');
        localStorage.setItem('localUserTourCliente', data.cliente.nome);
        this.usuarioCompleto = data;
        console.log(this.usuarioCompleto)
      },
        error => {
          //this.router.navigate(['/pages/login']);
        },
      )
    } else {
      //this.router.navigate(['/pages/login']);
    }
  }

  logoutS() {
    localStorage.clear();
    this.router.navigate(['/pages/login']);
  }

  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  openModal(editTrocaSenhaModal: TemplateRef<any>) {
    this.modalService.open(editTrocaSenhaModal, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    });
    this.selectedUsuario = this.usuarioCompleto;
  }

  abrirConfirmacao(confirmacaoModal: TemplateRef<any>, tipo: any, id: any) {
    this.acao = tipo;
    this.id = id;
    this.modalService.open(confirmacaoModal, {
      centered: true,
      backdrop: 'static'
    });
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    this.ngOnInit();
  }

  confirmacao() {
    this.trocarSenha();
  }

  trocarSenha() {
    console.log("teste")
    this.senhaTroca.senha = this.editTrocaSenha.get('senhaA')?.value;
    this.senhaTroca.novaSenha = this.editTrocaSenha.get('novaS')?.value;
    this.usuarioService.putSenhaT(this.senhaTroca, this.usuarioId.id);
    window.location.reload();
  }

  fechar() {
    this.modalService.dismissAll();
  }

}
